import { SimpleQueryResponse } from './../../dtos/simpleQueryResponse';
import { ReferentielDTO } from './../../dtos/referentielDTO';
import { SocieteLinkedModel } from './../../models/societe-linked/societe-linked.model';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { APICONSTANTS } from 'src/app/shared/constants/api-constants';
import { GenericCrudService } from '../basic/generic.crud.service';
import { HostnameService } from '../basic/hostname.service';
import { BasicWithLibelleModel } from '../../models/basic/basicWithLibelle.model';
import { ParamLandpageModel } from '../../models/simple-types/param-landpage.model';

@Injectable()
export class ParamLandpageService extends GenericCrudService<ParamLandpageModel> {
  constructor(http: HttpClient,
              protected toastrService: ToastrService,
              protected hostnameService: HostnameService) {
              super(http, toastrService, APICONSTANTS.ROUTEPARAMLANDPAGE, hostnameService);
  }

  updateAll(paramList: ParamLandpageModel[]): Observable<ParamLandpageModel[]> {
    return this.http.post<ParamLandpageModel[]>(APICONSTANTS.URLAPI.value + this.route + 'updateAll/', paramList).pipe(catchError( err => this.requestCatchError(err, 'UpdateAll')));
  }
}